module.exports = __webpack_public_path__ + "static/media/platform_mannual.5b402829.md";